module.exports = __webpack_public_path__ + "static/media/0_2019_03_13.05a00661.jpg";